import React, { useState, useEffect } from 'react';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { toast } from 'react-toastify';
import useSubmitLock from '../../utils/useSubmitLock';
import './addDocument.css';


function AddDocument({ internalId, onCloseModal, onSaveSuccess }) {
  const { addFiles } = useInternals();
  const { listTypeFiles } = useAuxiliaries();

  const [file, setFile] = useState(null);
  const [fileTypes, setFileTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [date, setDate] = useState('');
  const [description, setdescription] = useState('');
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  useEffect(() => {
    async function loadTypes() {
      try {
        const types = await listTypeFiles();
        if (Array.isArray(types.results)) {
          setFileTypes(types.results); // Define os tipos somente se forem um array
        } else {
          setFileTypes([]); // Define um array vazio caso a resposta não seja válida
        }
      } catch (error) {
        console.error("Erro ao carregar os tipos de arquivos:", error);
        setFileTypes([]); // Define um array vazio em caso de erro
      }
    }
    loadTypes();
  }, [listTypeFiles]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type !== 'application/pdf') {
      toast.error('Envie um arquivo em PDF.');
      event.target.value = '';
      setFile(null);
      return;
    }
    setFile(selectedFile);
  };

  const handleTypeToggle = (typeId) => {
    const value = String(typeId);
    setSelectedTypes((prev) => (
      prev.includes(value)
        ? prev.filter((id) => id !== value)
        : [...prev, value]
    ));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!file || selectedTypes.length === 0) {
        toast.warning("Please select a file and at least one type");
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('internal', internalId);
      const normalizedTypes = [...new Set(
        (selectedTypes || [])
          .map((type) => String(type).trim())
          .filter(Boolean)
      )];

      normalizedTypes.forEach((type) => formData.append('type', type));
      // Workaround para backend multipart: com apenas 1 item,
      // alguns ambientes convertem para int em vez de lista.
      // Repetimos o valor para preservar shape de lista.
      if (normalizedTypes.length === 1) {
        formData.append('type', normalizedTypes[0]);
      }
      formData.append('date', date);
      formData.append('description', description);

      const result = await addFiles(formData);
      if (!result) return;
      onSaveSuccess();
      onCloseModal();
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className='form-group modal-form'>
        <label>Documento:</label>
        <input type="file" accept="application/pdf" onChange={handleFileChange} required />
      </div>
      <div className='form-group modal-form'>
        <label>Tipo de Documento:</label>
        <div className="add-document-type-list" role="group" aria-label="Tipos de documento">
          {fileTypes.length === 0 ? (
            <p className="add-document-type-empty">Nenhum tipo de documento disponível.</p>
          ) : (
            fileTypes.map((type) => (
              <label key={type.id} className="add-document-type-option">
                <input
                  type="checkbox"
                  checked={selectedTypes.includes(String(type.id))}
                  onChange={() => handleTypeToggle(type.id)}
                />
                <span>{type.type}</span>
              </label>
            ))
          )}
        </div>
        <small className="add-document-type-help">Selecione um ou mais tipos.</small>
      </div>
      <div className='form-group modal-form'>
        <label>Data:</label>
        <input type="date" value={date} onChange={e => setDate(e.target.value)} />
      </div>
      <div className='form-group modal-form'>
        <label>Descrição:</label>
        <input type="text" value={description} onChange={e => setdescription(e.target.value)} placeholder='Descrição' required/>
      </div>
      <button type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'Adicionando...' : 'Adicionar'}
      </button>
    </form>
  );
}

export default AddDocument;
